import React from 'react';
import { Mail, User, MessageSquare, Send } from 'lucide-react';
import { ContactInfo } from './contact/ContactInfo';
import { FormField } from './contact/FormField';
import { useContactForm } from './contact/useContactForm';

export const ContactForm = () => {
  const { formData, isSubmitting, handleChange, handleSubmit } = useContactForm();

  return (
    <section id="contatti" className="section-container bg-bg-page py-24">
      <div className="container mx-auto px-8">
        <div className="max-w-2xl mx-auto">
          <ContactInfo />

          <form
            onSubmit={handleSubmit}
            className="contact-form bg-bg-card p-10 rounded-lg border border-border-medium"
          >
            <FormField
              id="name"
              name="name"
              label="Nome"
              icon={User}
              value={formData.name}
              onChange={handleChange}
              placeholder="Il tuo nome"
            />
            <FormField
              id="email"
              name="email"
              label="Email"
              icon={Mail}
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="tua@email.com"
            />
            <FormField
              id="message"
              name="message"
              label="Messaggio"
              icon={MessageSquare}
              value={formData.message}
              onChange={handleChange}
              placeholder="Scrivi qui il tuo messaggio..."
              rows="6"
            />

            <button
              type="submit"
              disabled={isSubmitting}
              className="btn-primary w-full flex items-center justify-center gap-2"
              data-testid="contact-submit-btn"
            >
              {isSubmitting ? (
                'Invio in corso...'
              ) : (
                <>
                  Invia Messaggio
                  <Send className="w-4 h-4" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
